export default __webpack_public_path__ + "static/media/finance.cec9a900.png";